import styled from 'styled-components';

export const CameraAccessPromptContainer = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	padding: 24px;
	text-align: center;
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 3;
	border-radius: 20px 20px 0px 0px;
	background: #fff;
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.25);
	& div {
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		& .one {
			background-color: var(--secondary-color-ff-secondary100);
			padding: 4px;
			width: 44px;
			height: 44px;
		}
		& .two {
			background-colorrgba(var(--secondary-color-ff-secondary100), 0.8);
			padding: 9px;
			width: 62px;
			height: 62px;
		}
		& .three {
			background-color: var(-secondary-color-ff-secondary50);
			padding: 6px;
			width: 74px;
			height: 80px;
		}
	}
	& > p {
		margin: 12px 0 24px 0;
	}
	& > .custom-button {
		& > button {
			padding: 5px 16px !important;
			border-radius: 100px !important;
			background: #4800ba !important;
			height: unset !important;
		}
	}
`;
